import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import { history }  from '../routers/AppRouter'
import PicListLoiTHelpingHands   from './PicListLoiTHelpingHands';
import PicListLoiTContributions from './PicListLoiTContributions';
// import { EmptyTableMsg } from './EmptyTableMsg';
import { ErrorMessage } from './ErrorMessage';
// import { PencilIcon } from './icons/PencilIcon';
// import { TrashIcon } from './icons/TrashIcon';
// import { LessThanIcon } from './icons/LessThanIcon';
import { ButtonWithShadow } from './buttons/ButtonWithShadow';
// import { SimpleButton } from './buttons/SimpleButton';
// import { ShadowButton } from './buttons/ShadowButton';
import { Title }     from './Title';
// import { PicListsInputBar } from './PicListsInputBar';
// import { SortableContainer, SortableElement, arrayMove,} from 'react-sortable-hoc';
// import todos from '../fixtures/todos';

// ****************************************************************** */
// PicListsPage component
// This component renders button with shadow on top for contributions and 
// helping hands. Based on which button it clicks, it renders the 
// either one of the tables.
// ****************************************************************** */
class PicListsPage extends React.Component {
  state = {
    items: [],
    item: '',
    qty:  '',
    editItem: false,      /* this tell onSubmit whether submission is for adding new item or editing existing*/
    edititemIndex: -1, 
    // firstTimeRender: true,   /* used to populate column 3 (edit/delete icons) on initial render */
    itemDragged: false,      /* used to track when item is dragged so I regenerate the JSX with index for edit delete icons */
    buttonClicked: 'firstButton',   
    formError: ''
  };

  
  /* this handler is used by ErrorMessage Component. When user clicks the X
     it clears the formError value and effectively closes the message box */
  clearErrorMessage = () => {
    this.setState({formError: ''})
  }
  
  onClickButtonWithShadow = (buttonClicked) => {
    if (buttonClicked === 'firstButton') {
      this.setState({buttonClicked: 'firstButton'})
    } else 
    if (buttonClicked === 'secndButton') {
      this.setState({buttonClicked: 'secondButton'})
    }
  }

  
  // ****************************************************************** */
  // Error Handler
  // ****************************************************************** */

  raiseError = (errorText) => {
    this.setState({
      formError: errorText
    })
  }

  // Render is used to toggle between the contributions list and the 
  // Helping Hands list based on which ButtonWithShadow was clicked.
  render() {
    // Pull errormsg from state, if any. ErrorMessage component will only render errormsg has text.
    let errormsg = this.state.formError || '';
    // let items_length = this.props.items.list !== undefined ? this.props.items.list.length : 0;
        
    /* based on which ButtonWithShadow was clicked, display either contribution list or item list */
    if (this.state.buttonClicked === "firstButton") {
      /* set up title */
      let titleText = "Contribution List";
      if (this.props.event.active._id) {titleText =  titleText + " for " + this.props.event.active.eventTitle}
      /* render List of contributions */
      return (
        <div className="tab-selection-panel">
          <div className="pic-lists-container">
              <ErrorMessage text={errormsg} allowClose={true} clearError={this.clearErrorMessage} />
              <Title text={titleText} />
              <ButtonWithShadow onClick={this.onClickButtonWithShadow} buttonPressed={this.state.buttonClicked}/>
              <PicListLoiTContributions buttonEventHandler={this.onClickButtonWithShadow} raiseError={this.raiseError} clearError={this.clearErrorMessage} />
          </div>
        </div>
      ); // end of return 
   } else {
     /* set up title */
     let titleText = "Help Needed";
     if (this.props.event.active._id) {titleText =  titleText + " for " + this.props.event.active.eventTitle}
     /* render List of Help Items */
     return (
          <div className="tab-selection-panel">
          <div className="pic-lists-container">
              <ErrorMessage text={errormsg} allowClose={true} clearError={this.clearErrorMessage} />
              <Title text={titleText} />
              <ButtonWithShadow onClick={this.onClickButtonWithShadow} buttonPressed={this.state.buttonClicked} />
              <PicListLoiTHelpingHands items={this.props.todos.list} buttonEventHandler={this.onClickButtonWithShadow} raiseError={this.raiseError} clearError={this.clearErrorMessage} />
          </div>
        </div>
     )
   }
  } // end of render() 
 

} /* end of class PicListsPage */

const mapStateToProps = (state) => {
  return {
      // auth:   state.auth,s
      items: state.items,
      event: state.event,
      todos: state.todos
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateItemList:       (list) => dispatch(updateItemList(list))
  // startGetParticipants:   () => dispatch(startGetParticipants()),
  // startAddNewParticipant: (newParticipant, participantsCopy) => dispatch(startAddNewParticipant(newParticipant, participantsCopy)),
  // startDeleteParticipants: (participantsArray) => dispatch(startDeleteParticipants(participantsArray)),
  // updateParticipants:     (participants) => dispatch(updateParticipants(participants))
});

export default connect(mapStateToProps, mapDispatchToProps)(PicListsPage);




// WEBPACK FOOTER //
// ./src/components/PicListsPage.js